import React from 'react'

interface AnalyticsIconProps {
	width?: number | string
	height?: number | string
	color?: string
	onClick?: () => void
	style?: React.CSSProperties
}

const AnalyticsIcon: React.FC<AnalyticsIconProps> = ({
	width = 24,
	height = 24,
	color = '#7F7F84',
	onClick,
	style,
}) => (
	<svg
		width={width}
		height={height}
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		onClick={onClick}
		style={{ cursor: onClick ? 'pointer' : 'default', ...style }}
	>
		<path
			d='M10.9978 21L10.9978 22L10.9978 21ZM3.00015 13L2.00017 12.9936L3.00015 13ZM9.99777 6V12H11.9978V6H9.99777ZM11.9978 14H18V12H11.9978V14ZM17.9437 13.8685C17.501 17.2678 14.5057 20 10.9978 20L10.9978 22C15.5379 22 19.3581 18.4949 19.9269 14.1268L17.9437 13.8685ZM4.00013 13.0064C4.02231 9.55975 6.704 6.50315 10.1294 6.05629L9.87069 4.0731C5.44742 4.65012 2.02874 8.5539 2.00017 12.9936L4.00013 13.0064ZM10.9978 20C7.23987 20 3.97614 16.7347 4.00013 13.0064L2.00017 12.9936C1.96896 17.8446 6.14349 22 10.9978 22L10.9978 20ZM9.99777 12C9.99777 13.1046 10.8932 14 11.9978 14V12L11.9978 12H9.99777ZM11.9978 6C11.9978 4.93552 11.1041 3.91219 9.87069 4.0731L10.1294 6.05629C10.1112 6.05867 10.086 6.05704 10.0604 6.0482C10.0364 6.03992 10.0206 6.02833 10.0118 6.01987C9.99603 6.00475 9.99777 5.99579 9.99777 6H11.9978ZM18 14C18.0042 14 17.9953 14.0017 17.9801 13.986C17.9716 13.9771 17.9601 13.9613 17.9518 13.9374C17.9429 13.9118 17.9413 13.8867 17.9437 13.8685L19.9269 14.1268C20.0876 12.8936 19.0646 12 18 12V14Z'
			fill={color}
		/>
		<path
			d='M20 10L20 11L20 10ZM20 9L15 9L15 11L20 11L20 9ZM15 9V4H13V9H15ZM18.2426 5.75736C19.1515 6.66621 19.7505 7.87412 19.9375 9.14872L21.9163 8.85834C21.668 7.16635 20.8757 5.56195 19.6569 4.34315L18.2426 5.75736ZM14.8513 4.06249C16.1259 4.24953 17.3338 4.84851 18.2426 5.75736L19.6569 4.34315C18.4381 3.12434 16.8337 2.33198 15.1417 2.08369L14.8513 4.06249ZM15 9L15 9H13C13 10.1046 13.8954 11 15 11L15 9ZM20 11C21.0583 11 22.0995 10.107 21.9163 8.85834L19.9375 9.14872C19.9345 9.12836 19.9359 9.10014 19.9456 9.07128C19.9548 9.04415 19.9678 9.02609 19.9775 9.01595C19.9948 8.99783 20.0049 9 20 9L20 11ZM15 4C15 3.99508 15.0022 4.00518 14.9841 4.02248C14.9739 4.03217 14.9559 4.04524 14.9287 4.05436C14.8999 4.06405 14.8716 4.06548 14.8513 4.06249L15.1417 2.08369C13.893 1.90046 13 2.94166 13 4H15Z'
			fill={color}
		/>
	</svg>
)

export default AnalyticsIcon
